import { Icon } from '@ui/lib/park/ui/icon';
import { PossibleBigNumber } from '@ui/types/utility';
import BigNumber from 'bignumber.js';
import { HStack } from 'styled-system/jsx';

import { LongArrowRight } from '../icons';
import { Amount, AmountProps } from './Amount';

export const Change = ({
  prevValue,
  nextValue,
  notSetCheck,
  containerDataCy,
  ...rest
}: Omit<AmountProps, 'value'> & {
  prevValue: BigNumber;
  nextValue: PossibleBigNumber;
  notSetCheck?: (nextValue: BigNumber) => React.ReactNode | undefined;
  containerDataCy?: string;
}) => {
  return (
    <HStack gap={1} justifyContent="end" data-cy={containerDataCy}>
      <Amount
        value={prevValue}
        textStyle="text.small"
        color="greyWhite.lightGrey3"
        {...rest}
        data-cy="PrevValue"
        data-cy-value={prevValue}
      />
      {!!nextValue && (
        <>
          <Icon boxSize="3" color="greyWhite.lightGrey3">
            <LongArrowRight />
          </Icon>
          {notSetCheck?.(nextValue) ?? (
            <Amount
              value={nextValue}
              textStyle="text.small"
              color="greyWhite.lightGrey1"
              {...rest}
              data-cy="NextValue"
              data-cy-value={nextValue}
            />
          )}
        </>
      )}
    </HStack>
  );
};
